
  
  <div class="site-mobile-menu site-navbar-target">
    <div class="site-mobile-menu-header">
      <div class="site-mobile-menu-close mt-3">
        <span class="icon-close2 js-menu-toggle"></span>
      </div>
    </div>
    <div class="site-mobile-menu-body"></div>
  </div>
 
      
      <header class="site-navbar js-sticky-header site-navbar-target" role="banner">
  
        <div style="padding-left: 5%;padding-right: 10px " >

          <div class="row align-items-center">
            <div class="col-6 col-xl-2" >
              <h1 class="mb-0 site-logo"><a routerLink="/" ><img [attr.src]="'assets/images/logo.png'" alt="logo" width="110px" height="60px">   </a></h1>
            </div>
  
            <div class="col-12 col-md-10 d-none d-xl-block">
              <nav    class="site-navigation position-relative text-right" role="navigation">
  
                <ul    class="site-menu main-menu js-clone-nav mr-auto d-none d-lg-block">
                  <li   ><a routerLinkActive="cl" routerLink="/chercher" style="color: #03506f !important;" class="nav-link">Chercher un concentrateur</a></li>
              
                  
                  <li><a routerLinkActive="cl" routerLink="/ajouter" style="color: #03506f !important;"  class="nav-link"> <span>Ajouter un concentrateur</span></a></li>
                  <li ><a    routerLinkActive="cl" routerLink="/contactus" style="color: #03506f !important;" class="nav-link">Contacter nous</a></li>
                  <li ><a routerLinkActive="cl" *ngIf="auth.loggedIn()" routerLink="/myposts"  style="color: #03506f !important; background-color:rgb(252, 252, 252)" class="nav-link">Mes publications</a></li>

                  <li  *ngIf="!auth.loggedIn()" ><a routerLinkActive="cl"   routerLink="/login" style="color: #03506f !important; background-color:rgb(252, 252, 252);"class="nav-link">Se connecter</a></li>
                  <li *ngIf="!auth.loggedIn()" ><a routerLinkActive="c2" routerLink="/signup" style="color: #030303 !important; background-color:#bae8e8"class="nav-link">S'inscrire</a></li>
                  <li *ngIf="auth.loggedIn()" ><a  routerLink="/logout"  style="color: #f3f3f3 !important; background-color:#f15f4c"class="nav-link">Se deconnecter</a></li>
          
                 <!--  <li   style="color: #03506f !important;" class="social"><a href="#contact-section" class="nav-link"><span class="icon-facebook"></span></a></li>
                  <li   style="color: #03506f !important;" class="social"><a href="#contact-section" class="nav-link"><span class="icon-twitter"></span></a></li>
                  <li  style="color: #03506f !important;" class="social"><a href="#contact-section" class="nav-link"><span class="icon-linkedin"></span></a></li>
                 --></ul>
              </nav>
            </div>
  
  
            <div class="col-6 d-inline-block d-xl-none ml-md-0 py-3" style="position: relative; top: 3px;"><a href="#" class="site-menu-toggle js-menu-toggle float-right"><span class="icon-menu h3"></span></a></div>
  
          </div>
        </div>
        
      </header>
  
    
  
    
      
      
<router-outlet></router-outlet>
<div class=" footer pb-0 justify-content-center text-light ">
    <footer>
        <div class="row justify-content-center py-5">
            <div class="col-11">
                <div class="row ">
                    <div class="col-xl-8 col-md-4 col-sm-4 col-12 my-auto mx-auto a">
                        <h3 class="text-muted mb-md-0 mb-5 bold-text">Oxygeni</h3>
                    </div>
                    <div class="col-xl-2 col-md-4 col-sm-4 col-12">
                        <h4 class="mb-3 mb-lg-4 bold-text "><b>MENU</b></h4>
                        <ul class="list-unstyled">
                            <li  routerLink="/" >Home</li>
                            <li  routerLink="/chercher">Chercher concentrateur</li>
                            <li  routerLink="/ajouter">Ajouter concentrateur</li>
                            <li  routerLink="/login">Se connecter</li>
                            <li  routerLink="/signup">S'inscrire</li>

                        </ul>
                    </div>
                    <div class="col-xl-2 col-md-4 col-sm-4 col-12">
                        <h4 class="mb-3 mb-lg-4 text-muted bold-text mt-sm-0 mt-5"><b>ADDRESS</b></h4>
                        <p class="mb-1">124,RUE ANBAR ,CITé MANAZEH,KALAA SEGHIRA</p>
                        <p>SOUSSE</p>
                    </div>
                </div>
                <div class="row ">
                    <div class="col-xl-8 col-md-4 col-sm-4 col-auto my-md-0 mt-5 order-sm-1 order-3 align-self-end">
                        <p class="social text-muted mb-0 pb-0 bold-text"> <span class="mx-2"><i class="fa fa-facebook" aria-hidden="true"></i></span> <span class="mx-2"><i class="fa fa-linkedin-square" aria-hidden="true"></i></span> <span class="mx-2"><i class="fa fa-twitter" aria-hidden="true"></i></span> <span class="mx-2"><i class="fa fa-instagram" aria-hidden="true"></i></span> </p><small class="rights"><span>&#174;</span> Oxygeni All Rights Reserved.</small>
                    </div>
                    <div class="col-xl-2 col-md-4 col-sm-4 col-auto order-1 align-self-end ">
                        <h6 class="mt-55 mt-2 text-muted bold-text"><b>POUR SIGNALE</b></h6><small> <span><i class="fa fa-envelope" aria-hidden="true"></i></span> oussema.belili@gmail.com</small>
                    </div>
                    <div class="col-xl-2 col-md-4 col-sm-4 col-auto order-2 align-self-end mt-3 ">
                        <h6 class="text-muted bold-text"><b>POUR PLUS D'INFORMATIONS</b></h6><small><span><i class="fa fa-envelope" aria-hidden="true"></i></span>oxygeni.tunisie@gmail.com</small>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</div>
